import { render, staticRenderFns } from "./ProofOfIdDialog.vue?vue&type=template&id=78b35a0f&"
import script from "./ProofOfIdDialog.vue?vue&type=script&lang=js&"
export * from "./ProofOfIdDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports